// extracted by mini-css-extract-plugin
export var wrapCards = "sceneGame-module--wrapCards--t0q2e";
export var wrapTips = "sceneGame-module--wrapTips--uvfMq";
export var showTips = "sceneGame-module--showTips--Jln2Y";
export var wrapTipsMobile = "sceneGame-module--wrapTipsMobile--8PQGQ";
export var tips = "sceneGame-module--tips--eA1rU";